import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MeteringPointsGuard } from '@metering/guards/metering-point.guard';
import { MeteringPointsDisplayComponent, MeteringPointDisplayComponent } from '@metering/containers';
import { MeteringPointsSelectedGuard } from '@metering/guards/metering-point-selected.guard';

const routes: Routes = [
  { 
    path: '',
    component: MeteringPointsDisplayComponent,
    canActivate: [MeteringPointsGuard],
    data: { name: 'MeteringPointsDisplayComponent' }
  },
  {
    path: 'disruptions',
    component: MeteringPointsDisplayComponent,
    canActivate: [MeteringPointsGuard],
    data: { name: 'MeteringPointsDisplayComponent' }
  },
  {
    path: 'groups',
    component: MeteringPointsDisplayComponent,
    canActivate: [MeteringPointsGuard],
    data: { name: 'MeteringPointsDisplayComponent' }
  },
  {
    path: ':mpId',
    component: MeteringPointDisplayComponent,
    canActivate: [MeteringPointsGuard, MeteringPointsSelectedGuard],
    data: { name: 'MeteringPointDisplayComponent' },
    pathMatch: 'full'
  },
  {
    path: ':mpId/:tabType',
    component: MeteringPointDisplayComponent,
    canActivate: [MeteringPointsGuard, MeteringPointsSelectedGuard],
    data: { name: 'MeteringPointDisplayComponent' },
    pathMatch: 'full'
  },
  {
    path: ':mpId/:contractId',
    component: MeteringPointDisplayComponent,
    canActivate: [MeteringPointsGuard, MeteringPointsSelectedGuard],
    data: { name: 'MeteringPointDisplayComponent' }
  },
  {
    path: ':mpId/serviceagreements/:agreementId',
    component: MeteringPointDisplayComponent,
    canActivate: [MeteringPointsGuard, MeteringPointsSelectedGuard],
    data: { name: 'MeteringPointDisplayComponent' }
  }
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MeteringPointsRoutingModule {}
